import { z } from "zod";

export const SearchSchema = z.object({
  textSearch: z.string().optional(),
  operationPackageId: z.string().optional(),
  anchorDateFrom: z.string().optional(),
  anchorDateTo: z.string().optional(),
  pageIndex: z.number().catch(0),
  pageSize: z.number().catch(100),
  orderBy: z
    .enum(["finishedAt", "createdAt", "anchorDate"])
    .optional()
    .catch("finishedAt"),
  orderDirection: z.enum(["asc", "desc"]).optional(),
}); // satisfies でバックエンドのQueryと一致させたいがバックエンドがCoreごとに存在するので一旦なし
export type SearchParams = z.infer<typeof SearchSchema>;
